export default "__VITE_ASSET__BTuUWnUh__"